import { Grid2 as Grid, FormControlLabel, Switch } from "@mui/material"
import Button from "@mui/material/Button"
import { Field, Formik } from "formik"
import { useMemo } from "react"
import * as yup from "yup"
import { ProduzioneFileDigitale } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { FormikDatePicker, FormikSelectVocabolario, FormikTextField } from "./formsHelpers"
import { useTranslation } from "react-i18next"
import { TcInOutField } from "./TcInOutField"


export default function ProduzioneFileDigitaleForm({ item, save, ref, language }: FormInDialogProps<ProduzioneFileDigitale>) {
  const { t } = useTranslation()
  const initialValues = useMemo(() => {
    return item ?? {
      tipologia_utilizzo: "",
      note_it: "",
      note_en: "",
      referente_archivio: "",
      liberatoria: false,
      data_liberatoria: "",
      pagamento: false,
      tcin_tcout: [{ tcin: "", tcout: "" }],

      
    }
  }, [item])

  const schema = useMemo(() => yup.object().shape({}), [t])

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as ProduzioneFileDigitale).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={12}>
                <Field
                  name="progetto"
                  label={t("fileDigitale.progetto")}
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid size={6}>
                <Field
                  name="tipologia_utilizzo"
                  label={t("fileDigitale.tipologia_utilizzo")}
                  component={FormikSelectVocabolario}
                  vocabolario="tipologia_utilizzo"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid size={12}>
                <TcInOutField name="tcin_tcout" label={t("fileDigitale.tcin_tcout")} />
                </Grid>
              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    name="note_tecniche_it"
                    label={t("fileDigitale.note_tecniche")}
                    component={FormikTextField}
                    margin="dense"
                    variant="outlined"
                    fullWidth
                    multiline
                   minRows={6}
                  />
                ) : (
                  <Field
                    name="note_tecniche_en"
                    label={t("fileDigitale.note_tecniche")}
                    component={FormikTextField}
                    margin="dense"
                    variant="outlined"
                    fullWidth
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>
              <Grid size={12}>
                <Field
                  name="referente_archivio"
                  label={t("fileDigitale.referente_archivio")}
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid size={4}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={values.liberatoria}
                      onChange={(e) => setFieldValue("liberatoria", e.target.checked)}
                    />
                  }
                  label={t("fileDigitale.liberatoria")}
                />
              </Grid>
              <Grid size={4}>
                <Field
                  component={FormikDatePicker}
                  name="data_liberatoria"
                  label={t("fileDigitale.data_liberatoria")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid size={4}>
                <FormControlLabel
                  control={
                    <Switch checked={values.pagamento} onChange={(e) => setFieldValue("pagamento", e.target.checked)} />
                  }
                  label={t("fileDigitale.pagamento")}
                />
              </Grid>
              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    name="note_it"
                    label={t("fileDigitale.note")}
                    component={FormikTextField}
                    margin="dense"
                    variant="outlined"
                    fullWidth
                    multiline
                   minRows={6}
                  />
                ) : (
                  <Field
                    name="note_en"
                    label={t("fileDigitale.note")}
                    component={FormikTextField}
                    margin="dense"
                    variant="outlined"
                    fullWidth
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>
              
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
